import { render, staticRenderFns } from "./RemoveFlightsDialog.vue?vue&type=template&id=9fbedb48&scoped=true&"
import script from "./RemoveFlightsDialog.vue?vue&type=script&lang=js&"
export * from "./RemoveFlightsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fbedb48",
  null
  
)

export default component.exports